<template>
  <div>
    <AccountingClientView v-if="$getConstRole('ROLE_ACCOUNTING') == role"></AccountingClientView>
    <AddNewClient v-if="$getConstRole('ROLE_AGENT') == role"></AddNewClient>
    <AdminClientUpdate v-if="$getConstRole('ROLE_ADMIN') == role"></AdminClientUpdate>
    <OperationsClientView v-if="$getConstRole('ROLE_OPERATIONS') == role"></OperationsClientView>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddNewClient from '@/views/agent/client/AddNewClient.vue'
import AdminClientUpdate from '@/views/admin/client/Update.vue'
import AccountingClientView from '@/views/accountant/client/View.vue'
import OperationsClientView from '@/views/operations/client/View.vue'

export default {
  name: 'Client',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    AddNewClient,
    AdminClientUpdate,
    AccountingClientView,
    OperationsClientView
  },
};
</script>
